import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material';
import { CompanyConfigurationComponent } from './company-configuration/company-configuration.component';
import { UserModalComponent } from './user-modal/user-modal.component';
import { CompanyConfigurationListComponent } from './company-configuration-list.component';
import { CompanyConfigurationService } from './service/company-configuration.service';

@NgModule({
  declarations: [
    CompanyConfigurationComponent,
    UserModalComponent,
    CompanyConfigurationListComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    RouterModule,
    MatSelectModule
  ],
  exports: [
    CompanyConfigurationComponent,
    UserModalComponent,
    CompanyConfigurationListComponent
  ],
  providers: [
    CompanyConfigurationService
  ]
})
export class CompanyConfigurationModule { }
